import React, { useEffect, useRef, useState } from "react";
import { useTerminal } from "../hooks/useTerminal";
import { useLabSocket } from "../hooks/useLabSocket";
import { useLabTasks } from "../hooks/useLabTasks";

const POINTS_PER_TASK = 10;

export default function Lab({
  labId,
  token,
  onExit,
  globalScore = 0,
  globalCompleted = 0,
  setGlobalScore,
  setGlobalCompleted,
}) {
  const termRef = useRef(null);
  const isReady = useRef(false);

  const terminal = useTerminal(termRef);
  const tasks = useLabTasks(labId);

  // ------------------------------------
  // Local State
  // ------------------------------------

  const [checkedTasks, setCheckedTasks] = useState([]);
  const [localCompleted, setLocalCompleted] = useState(0);
  const [localScore, setLocalScore] = useState(0);
  const [labCompleted, setLabCompleted] = useState(false);

  // ------------------------------------
  // Initialize when lab changes
  // ------------------------------------

  useEffect(() => {
      isReady.current = false;
    setCheckedTasks(new Array(tasks.length).fill(false));
    setLocalCompleted(0);
    setLocalScore(0);
    setLabCompleted(false);
  }, [labId, tasks.length]);

  // ------------------------------------
  // WebSocket
  // ------------------------------------

  const { send } = useLabSocket({
    labId,
    token,

    onOpen: () => {
      terminal.writeln("🟢 Connected");
    },

    onClose: () => {
      terminal.writeln("🔴 Disconnected");
    },

    onMessage: (data) => {

      if (data.type === "ready") {

        isReady.current = true;

        send({
          type: "sync",
        });

        terminal.writeln("🟢 Lab Ready");
      }

      if (data.type === "output") {
        terminal.write(data.data);
      }

    },
  });

  // ------------------------------------
  // Terminal Input
  // ------------------------------------

  useEffect(() => {

    const unsub = terminal.onData((input) => {

      if (!isReady.current) {
        terminal.writeln("⏳ Waiting for lab...");
        return;
      }

      send({
        type: "input",
        data: input,
      });

    });

    terminal.clear();
    terminal.writeln(`🚀 U2U LAB STARTED : ${labId}`);

    return unsub;

  }, [terminal, send, labId]);

  // ------------------------------------
  // Toggle Task Checkbox
  // ------------------------------------

  const toggleTask = (index) => {

    if (labCompleted) return;
/*
    const updated = [...checkedTasks];

    updated[index] = !updated[index];

    setCheckedTasks(updated);

    const completed = updated.filter(Boolean).length;

    setLocalCompleted(completed);
    */
    
    setCheckedTasks(prev => {

    const updated = [...prev];

    updated[index] = !updated[index];

    setLocalCompleted(updated.filter(Boolean).length);

    return updated;

});

  };

  // ------------------------------------
  // Complete Lab
  // ------------------------------------
/*
  const completeLab = () => {

    if (labCompleted) {

      terminal.writeln("");
      terminal.writeln("⚠ Lab already completed.");

      return;
    }
   if (localCompleted === 0) {

        alert("Please complete at least one task before submitting.");

        return;
    }
    const score = localCompleted * POINTS_PER_TASK;

    setLocalScore(score);

    // Update Parent Global Score

    if (setGlobalScore) {
      setGlobalScore((prev) => prev + score);
    }

    // Update Parent Global Completed

    if (setGlobalCompleted) {
      setGlobalCompleted((prev) => prev + localCompleted);
    }

    setLabCompleted(true);

    terminal.writeln("");
    terminal.writeln("================================");
    terminal.writeln("🎉 LAB COMPLETED");
    terminal.writeln("================================");
    terminal.writeln(
      `Completed Tasks : ${localCompleted}/${tasks.length}`
    );
    terminal.writeln(`Score Awarded : ${score}`);
    terminal.writeln("================================");
  };
  */
  const completeLab = async () => {

  if (labCompleted) {
    terminal.writeln("");
    terminal.writeln("⚠ Lab already completed.");
    return;
  }

  if (localCompleted === 0) {
    alert("Please complete at least one task before submitting.");
    return;
  }

  const score = localCompleted * POINTS_PER_TASK;

  setLocalScore(score);

  const newGlobalScore = globalScore + score;
  const newGlobalCompleted = globalCompleted + localCompleted;

  // Update Parent
  if (setGlobalScore) {
    setGlobalScore(newGlobalScore);
  }

  if (setGlobalCompleted) {
    setGlobalCompleted(newGlobalCompleted);
  }
console.log("Saving score...");
console.log("labId =", labId);
console.log("globalScore =", newGlobalScore);
  // ---------------------------------------
  // Save score to backend
  // ---------------------------------------

  try {

    await fetch("/api/save-score", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        labId,
        date: new Date().toLocaleString(),
        localScore: score,
        globalScore: newGlobalScore,
        taskCompleted: localCompleted,
        globalCompleted: newGlobalCompleted,
      }),
    });

  } catch (err) {
    console.error(err);
    terminal.writeln("⚠ Unable to save score file.");
  }

  setLabCompleted(true);

  terminal.writeln("");
  terminal.writeln("================================");
  terminal.writeln("🎉 LAB COMPLETED");
  terminal.writeln("================================");
  terminal.writeln(`Completed Tasks : ${localCompleted}/${tasks.length}`);
  terminal.writeln(`Score Awarded : ${score}`);
  terminal.writeln("================================");
};
  // ====================================
  // Progress Percentage
  // ====================================

  const progress =
    tasks.length === 0
      ? 0
      : Math.round((localCompleted / tasks.length) * 100);

  // ====================================
  // Render UI
  // ====================================

  return (
    <div
      style={{
        height: "100vh",
        background: "#000",
        color: "#0f0",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* ====================================
          HEADER
      ==================================== */}

      <div
        style={{
          padding: 10,
          display: "flex",
          flexWrap: "wrap",
          gap: 15,
          alignItems: "center",
          background: "#111",
          borderBottom: "1px solid #333",
        }}
      >
        <button
          onClick={onExit}
          style={{
            padding: "10px 18px",
            cursor: "pointer",
          }}
        >
          Exit
        </button>

        <button
          onClick={completeLab}
          disabled={labCompleted}
          style={{
            padding: "10px 18px",
            cursor: labCompleted ? "not-allowed" : "pointer",
            background: labCompleted ? "#666" : "#28a745",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            fontWeight: "bold",
          }}
        >
          {labCompleted
            ? "✔ Lab Completed"
            : "🎯 Lab Complete"}
        </button>

        <span
          style={{
            fontSize: 22,
            fontWeight: "bold",
          }}
        >
          
          🏆 Lab Score : {localScore} / {tasks.length * POINTS_PER_TASK}
        </span>

        <span
          style={{
            fontSize: 22,
            fontWeight: "bold",
          }}
        >
          ✔ Completed :
          {" "}
          {localCompleted}/{tasks.length}
        </span>

        <span
          style={{
            fontSize: 22,
            color: "#00ffff",
            fontWeight: "bold",
          }}
        >
          🌍 Global Score : {globalScore}
        </span>

        <span
          style={{
            fontSize: 22,
            color: "#ffff00",
            fontWeight: "bold",
          }}
        >
          📚 Global Completed :
          {" "}
          {globalCompleted}
        </span>
      </div>

      {/* ====================================
          TASK PANEL
      ==================================== */}

      <div
        style={{
          padding: 15,
          background: "#111",
          borderBottom: "1px solid #333",
        }}
      >
        <h2 style={{ marginTop: 0 }}>
          📋 Lab Tasks
        </h2>

        {tasks.length === 0 ? (
          <div>No Tasks Found</div>
        ) : (
          <div>

            {tasks.map((task, index) => (
              <div
                key={index}
                style={{
                  marginBottom: 12,
                }}
              >
                <label
                  style={{
                    cursor: labCompleted
                      ? "default"
                      : "pointer",
                    fontSize: 18,
                  }}
                >
                  <input
                    type="checkbox"
                    checked={checkedTasks[index] || false}
                    disabled={labCompleted}
                    onChange={() =>
                      toggleTask(index)
                    }
                    style={{
                      marginRight: 10,
                      transform: "scale(1.3)",
                    }}
                  />

                  {task}
                </label>
              </div>
            ))}

            {/* Progress */}

            <div
              style={{
                marginTop: 20,
              }}
            >
              <strong>
                Progress : {progress}%
              </strong>

              <div
                style={{
                  width: "100%",
                  height: 24,
                  background: "#444",
                  borderRadius: 20,
                  overflow: "hidden",
                  marginTop: 10,
                }}
              >
                <div
                  style={{
                    width: `${progress}%`,
                    height: "100%",
                    background:
                    progress === 100 ? "#28a745" : "#2196F3",
                    transition: "0.4s",
                  }}
                />
              </div>

            </div>

          </div>
        )}
      </div>

      {/* ====================================
          TERMINAL
      ==================================== */}

      <div
        ref={termRef}
        style={{
          flex: 1,
          minHeight: 0,
        }}
      />
      
          </div>
  );
}